// extracted by mini-css-extract-plugin
export var avatarContainer = "_53-1";
export var largeAvatarContainer = "_53-2";
export var smallAvatarContainer = "_53-0";